import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledHeader = styled.div`
margin: 1.5rem 1rem;
padding 10px 2vw;

@media only screen and (max-width: 600px) {
  margin: 1rem 0;
  padding: 10px 5px;
}

h1{
    color: ${props => props.theme.fontColor};
    font-size: calc(10pt + 1.2vw);
    font-weight: 300;
    text-align: center;
    margin-bottom: 10px;

    @media only screen and (max-width: 600px) {
        font-size: 15pt;
        font-weight: 400;
    }
  }
  `

type HeaderProps = {
  title: string
  children?: ReactNode
}
export const Header = ({ title, children }: HeaderProps) => {
  return (
    <StyledHeader>
      <h1>{title}</h1>
      {children}
    </StyledHeader>
  )
}
